import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "./components/sections/Header";
import { Hero } from "./components/sections/Hero";
import { Ribbon } from "./components/sections/Ribbon";
import { Services } from "./components/sections/Services";
import { Process } from "./components/sections/Process";
import { ServiceAreas } from "./components/sections/ServiceAreas";
import { Destinations } from "./components/sections/Destinations";
import { Gallery } from "./components/sections/Gallery";
import { About } from "./components/sections/About";
import { Manifesto } from "./components/sections/Manifesto";
import { Stats } from "./components/sections/Stats";
import { Testimonials } from "./components/sections/Testimonials";
import { Faq } from "./components/sections/Faq";
import { Contact } from "./components/sections/Contact";
import { Footer } from "./components/sections/Footer";

function App() {
  useEffect(() => {
    if (typeof window !== "undefined" && window.location.hash) {
      const id = window.location.hash;
      setTimeout(() => {
        const el = document.querySelector(id);
        if (el) el.scrollIntoView({ behavior: "auto" });
      }, 700);
    }
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined" && window.location.search.includes("nosmooth")) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-background">
      <div className="grain" />
      <Header />
      <main>
        <Hero />
        <Ribbon />
        <Services />
        <Process />
        <ServiceAreas />
        <Destinations />
        <Gallery />
        <About />
        <Manifesto />
        <Stats />
        <Testimonials />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
